import request from '../../../../../api/request';

const BASE = '/maintainers-portal/financial-portal/settings/financial-block';

export interface FinancialBlockConfig {
  id: number;
  /** Días transcurridos desde el vencimiento de una cuota impaga. */
  overdueDays: number;
  /** Mínimo de deudas en esa condición para activar el bloqueo. */
  overdueDebtsCount: number;
}

export interface FinancialBlockProcessItem {
  code: string;
  affected: boolean;
}

export interface FinancialBlockOverview {
  config: FinancialBlockConfig | null;
  processes: FinancialBlockProcessItem[];
}

export interface FinancialBlockConfigPayload {
  overdueDays: number;
  overdueDebtsCount: number;
}

export function getFinancialBlock() {
  return request<FinancialBlockOverview>(BASE);
}

export function createFinancialBlockConfig(body: FinancialBlockConfigPayload) {
  return request<FinancialBlockConfig>(BASE, { method: 'post', data: body });
}

export function updateFinancialBlockConfig(body: FinancialBlockConfigPayload) {
  return request<FinancialBlockConfig>(BASE, { method: 'put', data: body });
}

export function deleteFinancialBlockConfig() {
  return request<void>(BASE, { method: 'delete' });
}

export function replaceFinancialBlockProcesses(codes: string[]) {
  return request<void>(`${BASE}/processes`, {
    method: 'put',
    data: { codes },
  });
}
